import { createTheme } from '@mui/material/styles';

// Medieval Royal Theme
const theme = createTheme({
  typography: {
    // Primary font stack for body text
    fontFamily: "'Crimson Text', 'Libre Baskerville', 'Palatino Linotype', 'Book Antiqua', Palatino, Georgia, 'Times New Roman', serif",

    // Headings - Use Cinzel for elegant, formal titles
    h1: {
      fontFamily: "'Cinzel', 'Trajan Pro', 'Perpetua', 'Didot', 'Bodoni MT', Georgia, serif",
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
    h2: {
      fontFamily: "'Cinzel', 'Trajan Pro', 'Perpetua', 'Didot', 'Bodoni MT', Georgia, serif",
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
    h3: {
      fontFamily: "'Cinzel', 'Trajan Pro', 'Perpetua', 'Didot', 'Bodoni MT', Georgia, serif",
      fontWeight: 500,
      letterSpacing: '0.015em',
    },
    h4: {
      fontFamily: "'Cinzel', 'Trajan Pro', 'Perpetua', 'Didot', 'Bodoni MT', Georgia, serif",
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    h5: {
      fontFamily: "'Libre Baskerville', 'Crimson Text', Georgia, 'Times New Roman', serif",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "'Libre Baskerville', 'Crimson Text', Georgia, 'Times New Roman', serif",
      fontWeight: 600,
    },

    // Body text - Crimson Text for readability
    body1: {
      fontFamily: "'Crimson Text', 'Libre Baskerville', Georgia, 'Times New Roman', serif",
      fontSize: '1.05rem',
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: "'Crimson Text', 'Libre Baskerville', Georgia, 'Times New Roman', serif",
      fontSize: '0.95rem',
      lineHeight: 1.6,
    },

    // Buttons - Cinzel for elegance
    button: {
      fontFamily: "'Cinzel', Georgia, serif",
      fontWeight: 500,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },

    // Captions and subtitles
    caption: {
      fontFamily: "'Crimson Text', Georgia, 'Times New Roman', serif",
      fontStyle: 'italic',
      fontSize: '0.875rem',
    },

    subtitle1: {
      fontFamily: "'Libre Baskerville', Georgia, 'Times New Roman', serif",
      fontWeight: 600,
      fontSize: '1.05rem',
    },
    subtitle2: {
      fontFamily: "'Libre Baskerville', Georgia, 'Times New Roman', serif",
      fontWeight: 500,
      fontSize: '0.95rem',
    },
  },

  palette: {
    primary: {
      main: '#8D7B68',
      light: '#A0937D',
      dark: '#7A6859',
      contrastText: '#FAF3E0',
    },
    secondary: {
      main: '#3b2e22',
      light: '#59452E',
      dark: '#2C2416',
      contrastText: '#FAF3E0',
    },
    background: {
      default: '#FAF3E0',
      paper: '#F4ECE3',
    },
    text: {
      primary: '#2C2416',
      secondary: '#59452E',
    },
  },
});

export default theme;
